import { Box, Grid, Link, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { InputAdornment } from "@mui/material";
import Button from "@mui/material/Button";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import "../../Pages/OnBoardV2/custom.css";
import CommonUtil from "../../Util/CommonUtils";
import vis_forgot_password from "../../assets/USA_Images/login_images/forgotPass.svg";
import vis_forgot_pass from "../../assets/USA_Images/login_images/forgotpassword.svg";
import { ReactComponent as USAPassIcon } from "../../assets/USA_Images/login_images/pass_icon.svg";
import forgot_pass from "../../assets/images/onboard/forgot_pass_img.svg";
import forgot_password from "../../assets/images/onboard/forgot_password.svg";
import info from "../../assets/images/onboard/info.svg";
import USACustomTextfield from "../../components/CustomInputs/USACustomTextfield";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  validateActivationCode,
  validateCode,
} from "../../slices/Person/PersonSlice";
import LoginLayoutV2 from "../OnBoardV2/LoginLayoutV2";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "70%",
    marginTop: theme.spacing(3),
  },
  submit: {
    backgroundColor: "#36c96d",
    borderRadius: "0.2rem",
    padding: "10px",
    "&:hover": {
      background: "#119743",
    },
  },
}));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9d6",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #2281AB",
    marginRight: "180px",
  },
}));

function ActivateAccount(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const [values, setValues] = useState({
    password: "",
    showPassword: false,
    confirmPassword: "",
    confirmShowPassword: false,
    companyCode: "",
  });

  const [code, setCode] = useState("");

  useEffect(() => {
    var urlValue = window.location.href;
    var url = new URL(urlValue);
    var code = url.searchParams.get("code");
    setCode(code);
    dispatch(validateCode(code))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          history.push("/vis/activate-account");
        } else if (data.code === "CVAE0613") {
          //   history.push("/vis/result-page");
        } else {
          Toast(data.message, "error");
        }
      });
  }, []);

  const [error, setError] = useState({
    showPassword: false,
    confirmPassword: false,
  });

  const handleChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    setValues({
      ...values,
      [name]: value,
    });
    setError({
      [name]: false,
    });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleClickConfirmShowPassword = () => {
    setValues({ ...values, confirmShowPassword: !values.confirmShowPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const user = {
      password: values.password,
      confirmPassword: values.confirmPassword,
      code: code,
    };

    if (CommonUtil.isEmptyString(values.password)) {
      setError({ ...error, password: true });
      Toast(t("REGISTERUSER0002"), "error");
      return;
    }

    if (
      !values.password.match(
        /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/
      )
    ) {
      setError({ ...error, password: true });
      Toast(t("PASSWORDERROR"), "error");
      return;
    }

    if (CommonUtil.isEmptyString(values.confirmPassword)) {
      setError({ ...error, confirmPassword: true });
      Toast(t("REGISTERUSER0004"), "error");
      return;
    }

    if (
      !values.confirmPassword.match(
        /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/
      )
    ) {
      setError({ ...error, confirmPassword: true });
      Toast(t("PASSWORDERROR"), "error");
      return;
    }

    if (values.password !== values.confirmPassword) {
      setError({ ...error, confirmPassword: true });
      Toast(t("REGISTERUSER0007"), "error");
      return false;
    }

    dispatch(validateActivationCode(user))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0005") {
          history.push("/vis/password-success");
        } else {
          onFail(data);
        }
      })
      .catch((er) => {});
  };

  const onFail = (data) => {
    switch (data.code) {
      case "CVAE0604":
        Toast(t("REGISTERUSER0007"), "error");
        setError({ ...error, password: true });
        setError({ ...error, confirmPassword: true });
        break;
      case "CVAE0603":
        Toast("Password is required", "error");
        break;
      case "CVAE0605":
        Toast("Confirm Password is required", "error");
        break;
      case "CVAE0607":
        Toast(t("REGISTERUSER0007"), "error");
        break;
      case "CVAE0613":
        history.push("/vis/result-page");
        break;
      case "CVAE2036":
        history.push("/vis/login");
        Toast(
          data.message + ",Please login with your existing credentials.",
          "error"
        );
        break;
      case "UASE0046":
        history.push("/vis/result-page");
        break;
      default:
        break;
    }
  };

  return (
    <LoginLayoutV2
      lang={true}
      src={
        process.env.REACT_APP_ENVIRONMENT === "USA"
          ? vis_forgot_pass
          : forgot_pass
      }
    >
      <Grid className="center_div">
        <Grid container alignItems="center">
          <Grid item className="logo-center">
            <img
              src={
                process.env.REACT_APP_ENVIRONMENT === "USA"
                  ? vis_forgot_password
                  : forgot_password
              }
              alt="logo"
              style={{ width: "180px" }}
            />
          </Grid>
        </Grid>
        <form
          className={classes.form}
          noValidate
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          <Grid item xs={12}>
            <Typography
              variant="h2"
              align="left"
              gutterBottom
              style={{
                color: "#fff",
                fontWeight: "500",
                opacity: "0.9",
                marginBottom: "10px",
              }}
            >
              Account Activation
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs={11}>
                    <Grid className="company_icon">
                      <USAPassIcon className="visibleIcons" />
                    </Grid>

                    <USACustomTextfield
                      type={values.showPassword ? "text" : "password"}
                      error={error.password}
                      name="password"
                      label="New Password *"
                      value={values.password}
                      handleChange={(e) => handleChange(e)}
                      helperText={error.password}
                      inputProps={{ maxLength: 25 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              className="PasswordIcon"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {values.showPassword ? (
                                <Visibility className="visibleIcons" />
                              ) : (
                                <VisibilityOff className="visibleIcons" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  {/* Info Icon */}
                  <Grid item xs={1} style={{ textAlign: "center" }}>
                    <HtmlTooltip title="Password must be at least 8 characters long and contains at least 1 number, 1 uppercase character, 1 lowercase character and 1 special character">
                      <img src={info} alt="info" className="info_img" />
                    </HtmlTooltip>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs={11}>
                    <Grid className="company_icon">
                      <USAPassIcon className="visibleIcons" />
                    </Grid>

                    <USACustomTextfield
                      type={values.confirmShowPassword ? "text" : "password"}
                      error={error.confirmPassword}
                      name="confirmPassword"
                      label="Confirm Password *"
                      value={values.confirmPassword}
                      handleChange={(e) => handleChange(e)}
                      helperText={error.confirmPassword}
                      inputProps={{ maxLength: 25 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              className="PasswordIcon"
                              onClick={handleClickConfirmShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {values.confirmShowPassword ? (
                                <Visibility className="visibleIcons" />
                              ) : (
                                <VisibilityOff className="visibleIcons" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  {/* Info Icon */}
                  <Grid item xs={1} style={{ textAlign: "center" }}>
                    <HtmlTooltip title="Password must be at least 8 characters long and contains at least 1 number, 1 uppercase character, 1 lowercase character and 1 special character">
                      <img src={info} alt="info" className="info_img" />
                    </HtmlTooltip>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            alignItems="center"
            style={{ marginTop: "10px" }}
          >
            <Grid item xs>
              <Button fullWidth variant="contained" type="submit">
                {t("Account Activate")}
              </Button>
            </Grid>
            <Grid item></Grid>
          </Grid>
        </form>

        <Grid container alignItems="center">
          <Grid item xs>
            <Box mt={2} mb={2} align="center">
              <Typography
                variant="body2"
                color="textPrimary"
                align="center"
                style={{ fontSize: "12px", color: "#fff" }}
              >
                Back to{" "}
                <Link href="/vis/login" className="link_green">
                  {" "}
                  {t("LOGINFORM0002")}
                </Link>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </LoginLayoutV2>
  );
}

export default withRouter(ActivateAccount);
